// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-loading-indicator----styles-module---container---17v2w","dotAnimation":"src-components-loading-indicator----styles-module---dotAnimation---GQg3-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loading-indicator/styles.module.css
// module id = 630
// module chunks = 168707334958949